import { useEffect, useState } from "react";

const TARGET = (() => {
  // Set the next "drop" to 3 days from first visit
  const stored = typeof window !== "undefined" ? localStorage.getItem("ts_drop_target") : null;
  if (stored) return parseInt(stored, 10);
  const t = Date.now() + 1000 * 60 * 60 * 24 * 3 + 1000 * 60 * 60 * 14;
  if (typeof window !== "undefined") localStorage.setItem("ts_drop_target", String(t));
  return t;
})();

function pad(n) {
  return String(n).padStart(2, "0");
}

export default function Countdown() {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const i = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(i);
  }, []);

  const diff = Math.max(0, TARGET - now);
  const d = Math.floor(diff / (1000 * 60 * 60 * 24));
  const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const m = Math.floor((diff / (1000 * 60)) % 60);
  const s = Math.floor((diff / 1000) % 60);

  const blocks = [
    { v: pad(d), l: "DAYS" },
    { v: pad(h), l: "HRS" },
    { v: pad(m), l: "MIN" },
    { v: pad(s), l: "SEC" },
  ];

  return (
    <section data-testid="drop-countdown" className="border-y border-white/20 bg-ink">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10 sm:py-14 flex flex-col sm:flex-row items-center justify-between gap-6">
        <div>
          <p className="text-blood text-[10px] sm:text-xs tracking-[0.4em] font-mono">// DROP 002 — INCOMING</p>
          <h3 className="font-anton uppercase text-bone text-3xl sm:text-5xl tracking-tighter mt-1">
            UNTIL THE NEXT <span className="text-blood">DROP</span>
          </h3>
          <p className="font-marker text-bone text-lg sm:text-xl mt-1">don't sleep on it.</p>
        </div>
        <div className="flex gap-2 sm:gap-3">
          {blocks.map((b) => (
            <div key={b.l} className="border border-white/20 bg-surface px-3 sm:px-5 py-2 sm:py-3 text-center min-w-[64px] sm:min-w-[88px]">
              <div className="font-anton text-bone text-3xl sm:text-5xl tracking-tighter tabular-nums">{b.v}</div>
              <div className="text-[9px] sm:text-[10px] tracking-[0.3em] text-blood font-mono mt-1">{b.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
